import { createSlice } from '@reduxjs/toolkit'

export const notebooksSlice = createSlice({
  name: 'notebooks',
  initialState: {
    value: [],
  },
  reducers: {
    storeNotebooks: (state, action) => {
      state.value = action.payload
    },
    cleanNotebooks: (state) => {
        state.value = [];
    }
  },
})
export const { storeNotebooks, cleanNotebooks } = notebooksSlice.actions

export default notebooksSlice.reducer